(function () {
  if (window.__tlbDuoFreeInit) return;
  window.__tlbDuoFreeInit = true;
  var cache = new WeakMap();
  var money = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });

  function variants(card) {
    if (!cache.has(card)) {
      var data = card.querySelector('[data-duo-variants]');
      try { cache.set(card, data ? JSON.parse(data.textContent) : []); }
      catch (_) { cache.set(card, []); }
    }
    return cache.get(card);
  }

  function setPicture(row, choice) {
    var image = row.querySelector('img');
    if (!image || !choice || !choice.image) return;
    if (image.getAttribute('src') !== choice.image) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.setAttribute('src', choice.image);
      image.alt = choice.alt || choice.color || '';
    }
  }

  function selectRow(row, list) {
    var color = row.querySelector('[data-duo-color]');
    var length = row.querySelector('[data-duo-length]');
    var choices = Array.from(color.options);
    choices.forEach(function (option) {
      option.disabled = !list.some(function (v) { return v.available && v.key === option.value; });
    });
    if (!choices.some(function (option) { return option.value === color.value && !option.disabled; })) {
      var firstColor = choices.find(function (option) { return !option.disabled; });
      if (firstColor) color.value = firstColor.value;
    }
    Array.from(length.options).forEach(function (option) {
      option.disabled = !list.some(function (v) {
        return v.available && v.key === color.value && v.length === option.value;
      });
    });
    if (!length.selectedOptions.length || length.selectedOptions[0].disabled) {
      var firstLength = Array.from(length.options).find(function (option) { return !option.disabled; });
      if (firstLength) length.value = firstLength.value;
    }
    var selected = list.find(function (v) {
      return v.available && v.key === color.value && v.length === length.value;
    });
    row.querySelectorAll('[data-duo-swatch]').forEach(function (button) {
      var possible = list.some(function (v) { return v.available && v.key === button.dataset.duoKey; });
      button.disabled = !possible;
      button.setAttribute('aria-pressed', button.dataset.duoKey === color.value ? 'true' : 'false');
    });
    // Place la capsule selectionnee parmi les trois choix visibles.
    var strip = row.querySelector('.tlb-duo-free__swatches');
    var pressed = row.querySelector('[data-duo-swatch][aria-pressed="true"]');
    if (strip && pressed && strip.firstElementChild !== pressed) strip.insertBefore(pressed, strip.firstElementChild);
    if (selected) {
      var picked = row.querySelector('[data-duo-picked]');
      if (picked) picked.textContent = '· ' + selected.color;
      row.querySelector('[data-duo-item-price]').textContent = money.format(selected.price / 100);
      setPicture(row, selected);
    }
    return selected || null;
  }

  function update(card) {
    var list = variants(card);
    var selected = Array.from(card.querySelectorAll('[data-duo-item]')).map(function (row) {
      return selectRow(row, list);
    });
    var button = card.querySelector('[data-tlb-duo-add]');
    var valid = selected.length === 2 && selected.every(Boolean);
    if (valid) {
      var total = selected[0].price + selected[1].price;
      var discounted = Math.round(selected[0].price * .9) + Math.round(selected[1].price * .9);
      card.querySelector('[data-tlb-duo-original]').textContent = money.format(total / 100);
      card.querySelector('[data-tlb-duo-price]').textContent = money.format(discounted / 100);
      card.querySelector('[data-duo-saving]').textContent = money.format((total - discounted) / 100);
    }
    if (button.dataset.busy !== 'true') button.disabled = !valid;
    return valid ? selected : [];
  }

  function init(root) {
    root.querySelectorAll('[data-tlb-duo]').forEach(update);
  }

  document.addEventListener('variant:updated', function (event) {
    var form = event.target.closest && event.target.closest('product-form');
    var card = form && form.querySelector('[data-tlb-duo]');
    var chosen = event.detail && event.detail.resource;
    if (!card || !chosen || !chosen.id) return;
    var first = card.querySelector('[data-duo-index="1"]');
    if (!first || first.dataset.duoEdited === 'true') return;
    var match = variants(card).find(function (v) { return String(v.id) === String(chosen.id); });
    if (!match) return;
    first.querySelector('[data-duo-color]').value = match.key;
    first.querySelector('[data-duo-length]').value = match.length;
    update(card);
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-duo-color], [data-duo-length]')) return;
    var row = event.target.closest('[data-duo-item]');
    var card = event.target.closest('[data-tlb-duo]');
    if (!card || !row) return;
    if (row.dataset.duoIndex === '1') row.dataset.duoEdited = 'true';
    update(card);
  });

  document.addEventListener('click', function (event) {
    var more = event.target.closest('[data-duo-more]');
    if (!more) return;
    var palette = more.closest('.tlb-duo-free__palette');
    var strip = palette && palette.querySelector('.tlb-duo-free__swatches');
    if (!strip) return;
    var expanded = !strip.classList.contains('is-expanded');
    strip.classList.toggle('is-expanded', expanded);
    more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    more.textContent = expanded ? 'Voir moins' : 'Voir plus';
  });

  document.addEventListener('click', function (event) {
    var capsule = event.target.closest('[data-duo-swatch]');
    if (!capsule || capsule.disabled) return;
    var row = capsule.closest('[data-duo-item]');
    var card = capsule.closest('[data-tlb-duo]');
    if (!row || !card) return;
    var color = row.querySelector('[data-duo-color]');
    color.value = capsule.dataset.duoKey;
    if (row.dataset.duoIndex === '1') row.dataset.duoEdited = 'true';
    update(card);
  });

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-tlb-duo-add]');
    if (!button || button.disabled) return;
    var card = button.closest('[data-tlb-duo]');
    var selected = update(card);
    if (selected.length !== 2) return;
    var status = card.querySelector('[data-tlb-duo-status]');
    var original = button.textContent;
    button.dataset.busy = 'true';
    button.disabled = true;
    button.textContent = 'Ajout en cours…';
    status.textContent = '';
    try {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      root = root.endsWith('/') ? root : root + '/';
      var items = [];
      selected.forEach(function (choice) {
        var line = items.find(function (entry) { return String(entry.id) === String(choice.id); });
        if (line) line.quantity += 1;
        else items.push({ id: choice.id, quantity: 1 });
      });
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!response.ok) throw new Error('Impossible d’ajouter les deux tresses');
      window.location.assign(root + 'cart');
    } catch (_) {
      status.textContent = 'L’ajout a échoué. Veuillez réessayer.';
      button.dataset.busy = 'false';
      button.disabled = false;
      button.textContent = original;
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
